import { SelectChangeEvent, Typography } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import React from 'react'

export interface SingleSelectDropdownProps<T> {
    state: T
    changeFunction: (arg: T) => void
    options: T[]
    label: string
    maxWidth?: number | string
    fieldRequired?: boolean
    fullWidth?: boolean
}

export default function SingleSelectDropdown<T>({
    state,
    changeFunction,
    options,
    label,
    maxWidth,
    fieldRequired,
    fullWidth,
}: SingleSelectDropdownProps<T>) {
    const handleChange = (event: SelectChangeEvent<T>) => {
        changeFunction(event.target.value as T)
    }

    return (
        <>
            <Typography sx={{ fontWeight: 'bold', paddingLeft: '4px' }}>
                {label}
                {fieldRequired && <span style={{ color: 'rgba(0, 101, 173, 1)' }}>*</span>}
            </Typography>
            <Select
                data-test="single-select-dropdown"
                labelId="status selection"
                id="list-select"
                value={state}
                placeholder={label}
                onChange={handleChange}
                sx={{ maxWidth: maxWidth, minWidth: maxWidth }}
                fullWidth={fullWidth}
            >
                {options.map((element) => {
                    return (
                        <MenuItem
                            data-test="single-select-dropdown-item"
                            key={element as string}
                            value={element as string}
                        >
                            {`${element as string}`}
                        </MenuItem>
                    )
                })}
            </Select>
        </>
    )
}
